(() => {
  const init = () => {
    const sections = document.querySelectorAll('[data-shop-categories]');
    if (!sections.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const revealSection = (section) => {
      const items = section.querySelectorAll('[data-shop-categories-item]');
      items.forEach((item) => item.classList.add('is-revealed'));
    };

    if (prefersReducedMotion) {
      sections.forEach(revealSection);
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const section = entry.target;
          revealSection(section);
          io.unobserve(section);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -15% 0px',
        threshold: 0.12,
      }
    );

    sections.forEach((section) => io.observe(section));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
